import React from 'react';

import { ButtonPrimary } from '../../../StyledComponent';
import { BlockParcelsStyled } from './styles';

export default function BlockParcells({
  tema,
  setshowParcelasPagas,
  setshowParcelasPagar,
}) {
  return (
    <BlockParcelsStyled color={tema?.primaryColor}>
      <h4>Financeiro fora do horário de funcionamento</h4>
      <p>
        Retorne a partir das <span style={{ fontWeight: 500 }}>08h00 </span>para
        realizar pagamentos e renegociações.
      </p>
      <p>
        Enquanto isso, você ainda pode gerar extratos e ver suas parcelas pagas.
      </p>
      <ButtonPrimary
        tema={tema}
        onClick={() => {
          setshowParcelasPagar(false);
          setshowParcelasPagas(true);
        }}
        width={332}
      >
        Ver parcelas pagas
      </ButtonPrimary>
    </BlockParcelsStyled>
  );
}
